import { DealerItem } from '../../../shared/filtro-dealers/filtro-dealers.component';

export class FiltroDealers {

  dealers: DealerItem[] = [];

  constructor() { }

  public selecionados(): any {
    let selecionados = [];
    selecionados = this.dealers.filter(m => m.selecionado).map(m => m);

    return selecionados;
  }

  public naoSelecionados(): any {
    let selecionados = [];
    selecionados = this.dealers.filter(m => !m.selecionado).map(m => m);

    return selecionados;
  }

  public preencher(dados: any) {
    // Limpa dealers anteriores antes de preencher novos
    this.dealers = [];
    this.inserirItens(dados);
  }

  public limparSelecionados() {
    this.dealers.forEach(dealer => {
      dealer.selecionado = false;
    });
  }

  private inserirItens(dados: any) {
    dados.forEach(dealer => {
      const item: DealerItem = {
        'id': dealer.id,
        'nome': dealer.nome || dealer.descricao,
        'toTexto': function() { return this.nome},
        'toDescricao': function() { return null },
        'selecionado': false
      };
      this.dealers.push(item);
    });                                                            
  }
}
